import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';

const ButtonForm = (props)=>{
    return(
        <RaisedButton 
            className="action-btn" 
            label={props.label}
            onClick={(e)=>props.action(e)} 
            style={props.styles}
            primary={props.primary}
            disabled={props.disabled}
        />
    )
}

export default ButtonForm;

ButtonForm.defaultProps = {
    styles:{margin: 7},
    primary:true,
    disabled:false
}